import { httpsCallable } from 'firebase/functions';
import { functions } from './config';

/**
 * Instagram'a post at
 * @param {string} caption - Post yazısı
 * @param {string} imageUrl - Tek resim URL'si (backward compatibility)
 * @param {array} imageUrls - Çoklu resim URL'leri
 * @param {string} videoUrl - Video URL'si
 * @param {object} platformData - Instagram platform bilgileri (token, userId, vb.)
 * @param {string} postType - Post türü: 'feed' veya 'story'
 * @param {number} selectedStoryMediaIndex - Story için seçili medya index'i
 */
export const postToInstagram = async (caption, imageUrl, imageUrls, videoUrl, platformData, postType, selectedStoryMediaIndex) => {
  try {
    const postToInstagramFunction = httpsCallable(functions, 'postToInstagram');

    const result = await postToInstagramFunction({
      caption,
      imageUrl,
      imageUrls,
      videoUrl,
      platformData,
      postType,
      selectedStoryMediaIndex
    });

    return {
      success: true,
      data: result.data
    };
  } catch (error) {
    console.error('Instagram post error:', error);
    // Firebase Functions hatası için detaylı mesaj çıkar
    let errorMessage = 'Instagram post hatası';

    if (error.details) {
      // Firebase Functions'dan gelen detaylı hata
      errorMessage = error.details;
    } else if (error.message && error.message !== 'INTERNAL' && error.message !== 'internal') {
      // Normal error message
      errorMessage = error.message;
    } else if (error.code) {
      // Sadece kod varsa
      errorMessage = `Hata kodu: ${error.code}`;
    }

    console.error('Instagram error message:', errorMessage);

    return {
      success: false,
      error: errorMessage
    };
  }
};

/**
 * LinkedIn'e post at
 */
export const postToLinkedIn = async (message, imageUrl, imageUrls, videoUrl, platformData) => {
  try {
    const postToLinkedInFunction = httpsCallable(functions, 'postToLinkedIn');

    const result = await postToLinkedInFunction({
      message,
      imageUrl,
      imageUrls,
      videoUrl,
      platformData
    });

    return {
      success: true,
      data: result.data
    };
  } catch (error) {
    console.error('LinkedIn post error:', error);
    let errorMessage = 'LinkedIn post hatası';

    if (error.details) {
      errorMessage = error.details;
    } else if (error.message && error.message !== 'INTERNAL' && error.message !== 'internal') {
      errorMessage = error.message;
    } else if (error.code) {
      errorMessage = `Hata kodu: ${error.code}`;
    }

    return {
      success: false,
      error: errorMessage
    };
  }
};

/**
 * Facebook'a post at
 * @param {string} message - Post yazısı
 * @param {string} imageUrl - Tek resim URL'si (backward compatibility)
 * @param {array} imageUrls - Çoklu resim URL'leri
 * @param {string} videoUrl - Video URL'si
 * @param {object} platformData - Facebook platform bilgileri (token, pageId, vb.)
 */
export const postToFacebook = async (message, imageUrl, imageUrls, videoUrl, platformData) => {
  try {
    const postToFacebookFunction = httpsCallable(functions, 'postToFacebook');

    const result = await postToFacebookFunction({
      message,
      imageUrl,
      imageUrls,
      videoUrl,
      platformData
    });

    return {
      success: true,
      data: result.data
    };
  } catch (error) {
    console.error('Facebook post error:', error);
    // Firebase Functions hatası için detaylı mesaj çıkar
    let errorMessage = 'Facebook post hatası';

    if (error.details) {
      // Firebase Functions'dan gelen detaylı hata
      errorMessage = error.details;
    } else if (error.message && error.message !== 'INTERNAL' && error.message !== 'internal') {
      // Normal error message
      errorMessage = error.message;
    } else if (error.code) {
      // Sadece kod varsa
      errorMessage = `Hata kodu: ${error.code}`;
    }

    console.error('Facebook error message:', errorMessage);

    return {
      success: false,
      error: errorMessage
    };
  }
};

/**
 * Birden fazla platforma aynı anda post at
 * @param {object} postData - Post bilgileri (content, imageUrl, imageUrls, videoUrl)
 * @param {Array} platforms - Post atılacak platformlar ve bilgileri
 */
export const postToMultiplePlatforms = async (postData, platforms) => {
  const results = [];

  for (const platform of platforms) {
    try {
      let result;

      if (platform.id === 'instagram') {
        result = await postToInstagram(
          postData.content,
          postData.imageUrl,
          postData.imageUrls,
          postData.videoUrl,
          platform,
          platform.postType || 'feed',
          platform.selectedStoryMediaIndex || 0
        );
      } else if (platform.id === 'facebook') {
        result = await postToFacebook(
          postData.content,
          postData.imageUrl,
          postData.imageUrls,
          postData.videoUrl,
          platform
        );
      } else if (platform.id === 'linkedin') {
        result = await postToLinkedIn(
          postData.content,
          postData.imageUrl,
          postData.imageUrls,
          postData.videoUrl,
          platform
        );
      } else {
        result = {
          success: false,
          error: `${platform.id} için posting henüz desteklenmiyor`
        };
      }

      results.push({
        platform: platform.id,
        platformName: platform.displayName || platform.name,
        ...result
      });
    } catch (error) {
      results.push({
        platform: platform.id,
        platformName: platform.displayName || platform.name,
        success: false,
        error: error.message
      });
    }
  }

  return results;
};
